import React, { useState } from "react"
import propTypes from "prop-types"
import Fade from "react-reveal/Fade"
import { useSwipeable } from "react-swipeable"

import Accordion from "../common/Accordion"

import CrueltyFreeIcon from "../../assets/images/tags/CrueltyFree.svg"
import GlutenFreeIcon from "../../assets/images/tags/GlutenFree.svg"
import NaturallyDerivedIngredientsIcon from "../../assets/images/tags/NaturallyDerivedIngredients.svg"
import NaturallyWhiterTeethIcon from "../../assets/images/tags/NaturallyWhiterTeeth.svg"
import SustainableIcon from "../../assets/images/tags/Sustainable.svg"
import VeganFriendlyIcon from "../../assets/images/tags/VeganFriendly.svg"
import BioTubeIcon from "../../assets/images/tags/BioTube.svg"
import Biodegradable from "../../assets/images/tags/Biodegradable.svg"

import "./ProductDetail.scss"

const pros = [
  {
    title: "Vegan",
    image: VeganFriendlyIcon,
  },
  {
    title: "Gluten Free",
    image: GlutenFreeIcon,
  },
  {
    title: "Cruelty Free",
    image: CrueltyFreeIcon,
  },
  {
    title: "Biodegradable Tube",
    image: BioTubeIcon,
  },
  {
    title: "Biodegradable",
    image: Biodegradable,
  },
  {
    title: "Sustainable",
    image: SustainableIcon,
  },
  {
    title: "Naturally Derived Ingredients",
    image: NaturallyDerivedIngredientsIcon,
  },
  {
    title: "Naturally Whiter Teeth",
    image: NaturallyWhiterTeethIcon,
  },
]

const ProductDetail = ({ product, addVariantToCart, wpProduct, sellingPlan }) => {
  const [quantity, setQuantity] = React.useState(1)
  const [variant, setVariant] = React.useState(0)
  const [plan, setPlan] = React.useState(0)

  const addItemToCart = (variant_id, qty, selling_plan)  => {

    let shopify_domain = "rocc-naturals.myshopify.com"

    let data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": selling_plan
    }

    let url = `https://${shopify_domain}/cart/clear?return_to=/cart/add?items[][id]=${variant_id}%26items[][quantity]=${qty}%26items[][selling_plan]=${selling_plan}%26return_to=/checkout`
    window.location.href = url;
  }

  const AccordionData = [
    {
      title: "Ingredients",
      description: wpProduct ? wpProduct.product_details.ingredients : "",
    },

    {
      title: "How To Use",
      description: wpProduct ? wpProduct.product_details.howToUse : "",
    },
    {
      title: "Shipping & Returns",
      description: wpProduct
      ? wpProduct.product_details.shippingAndReturns
      : "",
    },
  ]

  const updateQuantity = (event) => {
    const wholeNumberCheck =
      event.target.value - Math.floor(event.target.value) === 0 // x.y - x = 0.y which is != 0...so returns false

    if (event.target.value > -1 && wholeNumberCheck)
      setQuantity(event.target.value)
    else setQuantity(0)
  }

  const updateVariant = (event) => {
    setVariant(parseInt(event.target.value) || 0)
  }

  const changeSlide = (n) => {
    const slides = document.querySelectorAll(
      ".product-detail__left__slider__slide"
    )

    const images = document.querySelectorAll(
      ".product-detail__left__slider__slide__image"
    )

    slides.forEach((slide, index) => {
      if (index === n) {
        slide.style.display = "block"
        images[index].style.display = "block"
      } else {
        slide.style.display = "none"
        images[index].style.display = "none"
      }
    })
  }
  const [slideIndex, setSlideIndex] = useState(0)

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (slideIndex + 1 < product.images.length) {
        changeSlide(slideIndex + 1)
        setSlideIndex(slideIndex + 1)
      } else {
        changeSlide(0)
        setSlideIndex(0)
      }
    },
    onSwipedRight: () => {
      changeSlide(slideIndex - 1)
      setSlideIndex(slideIndex - 1)
      if (slideIndex - 1 > 0) {
        changeSlide(slideIndex - 1)
        setSlideIndex(slideIndex - 1)
      } else {
        changeSlide(product.images.length - 1)
        setSlideIndex(product.images.length - 1)
      }
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  })

  return (
    <Fade>
    <div className="product-detail">
    <div className="product-detail__left">
    <div className="product-detail__left__slider" {...handlers}>
    {product.images.map((image) => {
      return (
        <div
        key={image.id}
        className="product-detail__left__slider__slide"
        >
        <img
        className="product-detail__left__slider__slide__image"
        src={image.originalSrc}
        />
        </div>
      )
    })}
    </div>

    <div className="product-detail__left__carousel">
    {product.images.map((image, index) => {
      return (
        <div
        key={image.id}
        className="product-detail__left__carousel--image"
        >
        <img
        src={image.originalSrc}
        alt="product"
        onClick={() => {
          changeSlide(index)
        }}
        />
        </div>
      )
    })}
    </div>
    </div>

    <div className="product-detail__right">
    <div className="product-detail__right__title">
    <div className="product-detail__right__title__name">
    <h1>{product.title}</h1>
    {wpProduct && <p>{wpProduct.product_details.subtitle}</p>}
    </div>

    <h2 className="product-detail__right__title__price">
    &#36;{" "}
    {parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2)}
    </h2>
    </div>

    <div
    className="product-detail__right__description"
    dangerouslySetInnerHTML={{
      __html: product.descriptionHtml,
    }}
    />

    <div className="product-detail__right__pros">
    {pros.map(
      (pro, index) =>
      product.tags.includes(pro.title) && (
        <div key={index} className="product-detail__right__pros__pro">
        <>
        <img
        src={pro.image}
        className="product-detail__right__pros__pro__icon"
        />

        <p className="product-detail__right__pros__pro__title">
        {pro.title}
        </p>
        </>
        </div>
      )
    )}
    </div>

    { product.variants.length > 1 &&
      <div className="product-detail__right__cart">
        <label><span>Select Flavour</span>
          <select onChange={updateVariant} name='variants'>
            { product.variants.map((el, i) => (<option key={i} value={i}>{ el.title }</option>)) }
          </select>
        </label>
      </div>
    }

    { product.requiresSellingPlan && sellingPlan?.length > 1 &&
      <div className="product-detail__right__cart">
        <select onChange={() => {}} name='selling_plans'>
          { sellingPlan?.map((el, i) => (<option key={i} value={el.selling_plan_id}>{ el.selling_plan_name }</option>)) }
        </select>
      </div>
    }

    <div className="product-detail__right__cart">
    { !product.requiresSellingPlan &&
      <input
      type="text"
      className="product-detail__right__cart__count"
      value={quantity}
      onChange={updateQuantity}
      />
    }

    <button
    className="product-detail__right__cart--button"
    onClick={() => {
      let selling_plan = "No"
      if (product.requiresSellingPlan) {
        selling_plan = sellingPlan[plan].selling_plan_id + ''
        addItemToCart(product.variants[variant].legacyResourceId, quantity, selling_plan)
      } else {
        quantity > 0
          ? addVariantToCart(product.variants[variant].storefrontId, quantity, selling_plan)
          : alert("add atleast 1 item")
      }
    }}
    >
      { product.requiresSellingPlan ? 'Subscribe' : 'Add to Cart' }
    </button>
    </div>

    {wpProduct && (
      <div className="product-detail__right__accordian">
      <Accordion accordion={AccordionData} />
      </div>
    )}
    </div>
    </div>
    </Fade>
  )
}

ProductDetail.propTypes = {
  product: propTypes.object.isRequired,
  wpProduct: propTypes.object.isRequired,
  addVariantToCart: propTypes.func.isRequired,
}

export default ProductDetail
